import { render, staticRenderFns } from "./SettsLanding.vue?vue&type=template&id=e2d9ca40&scoped=true"
import script from "./SettsLanding.vue?vue&type=script&lang=js"
export * from "./SettsLanding.vue?vue&type=script&lang=js"
import style0 from "./SettsLanding.vue?vue&type=style&index=0&id=e2d9ca40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d9ca40",
  null
  
)

export default component.exports